import styled from '@emotion/styled';
import { Link } from '@vmos2/design-system';
import { useSettings } from '@vmos2/providers';
import type { ReactNode } from 'react';
import React, { useMemo } from 'react';

type Props = {
  brandSlug?: string,
  children: ReactNode,
  page?: string,
};

export const pages = {
  checkout: 'checkout',
  rewards: 'rewards',
};

export const RewardsExternalLink = ({ brandSlug, children, page = pages.checkout }: Props) => {
  const { loyaltyRewardsExternalLink } = useSettings();
  const pageSettings = (loyaltyRewardsExternalLink && loyaltyRewardsExternalLink[page]) || null;

  const url = useMemo(() => {
    const { brandUrls = [], defaultUrl } = pageSettings || {};

    let url = null;

    if (brandUrls?.length) {
      url = brandUrls.find(brandSetting => brandSetting.brand === brandSlug)?.url || null;
    }

    if (!url && defaultUrl) {
      url = defaultUrl;
    }

    return url;
  }, [pageSettings, brandSlug]);

  if (!pageSettings || !url) {
    return null;
  }

  return (
    <Container data-test="external-link">
      <LinkWrapper dataTest="rewards-list-external-link" href={url} level={4} rel="noopener noreferrer" url={url}>
        {children}
      </LinkWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: block;
`;

const LinkWrapper = styled(Link)`
  text-decoration: underline;
  color: ${({ theme }) => theme.color.grey};
`;
